import { colorPrimitives } from 'components/Theme'

export const ErrorIndicator = ({
  message = 'Something went wrong',
  style,
  color = colorPrimitives.black,
}: {
  message?: string
  style?: string
  color?: string
}) => {
  const newText = message.split('\n')
  return (
    <div>
      {newText.map((str, index) => (
        <p className={style} style={{ color }} key={`${str}-${index}`}>
          {str}
        </p>
      ))}
    </div>
  )
}
